import { z } from 'zod'

export const MEMBERSHIP_INVITES_WRITE_CONTRACT_VERSION = '1.0.1' as const
const numericId = z.string().regex(/^[0-9]+$/)
const email = z.string().email().max(320)
const delivery = z.object({
  channel: z.literal('email'), provider: z.literal('mandrill'), status: z.literal('blocked_email_gate_closed'),
  reason: z.literal('email_delivery_disabled'), material: z.literal('invite_token_not_persisted'),
  auditAction: z.literal('invite_delivery_blocked'), emailSent: z.literal(false), rawTokenReturned: z.literal(false),
  providerMessageId: z.null(),
}).strict()

export const membershipInviteCreateRequestSchema = z.object({
  orgId: numericId,
  email,
  roleDefinitionId: numericId,
  productGrants: z.array(z.unknown()).max(0).optional(),
}).strict()
export const membershipInviteResendRequestSchema = z.object({}).strict()
export const membershipInviteRevokeRequestSchema = z.object({}).strict()

export const membershipInviteCreateResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_INVITES_WRITE_CONTRACT_VERSION), inviteId: numericId, expiresAt: z.string().datetime(),
  emailQueued: z.literal(false), delivery,
}).passthrough()
export const membershipInviteResendResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_INVITES_WRITE_CONTRACT_VERSION), inviteId: numericId, emailQueued: z.literal(false),
  expiresAt: z.string().datetime(), resendCount: z.number().int().nonnegative(), delivery,
}).passthrough()
export const membershipInviteRevokeResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_INVITES_WRITE_CONTRACT_VERSION), revoked: z.boolean(), inviteId: numericId,
}).passthrough()

export type MembershipInviteCreateRequest = z.infer<typeof membershipInviteCreateRequestSchema>
export type MembershipInviteResendRequest = z.infer<typeof membershipInviteResendRequestSchema>
export type MembershipInviteRevokeRequest = z.infer<typeof membershipInviteRevokeRequestSchema>
export type MembershipInviteCreateResponse = z.infer<typeof membershipInviteCreateResponseSchema>
export type MembershipInviteResendResponse = z.infer<typeof membershipInviteResendResponseSchema>
export type MembershipInviteRevokeResponse = z.infer<typeof membershipInviteRevokeResponseSchema>
